import React from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage } from 'react-intl';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import messages from '../jobMessages';

const JobDetailChangeTaskTags = ({ job, intl }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);
  if (!parameters || !parameters.tags || parameters.tags.length === 0) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-2 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Tags} />
                  </b>
                </label>
              </div>
              <div className="col-md-10 col-sm-6">
                <ul>
                  {parameters.tags.map(x => (
                    <li key={x.id}>{x.name}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailChangeTaskTags.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailChangeTaskTags);
